import { URN as NSURN } from './utils/urn';
import { NSServerCalls } from './utils/servercalls';
import { NSResultsInterface } from './results_interface';
import { NSPageBottompanel} from './page_bottompanel';


export let NSObjJoinList = {};

NSObjJoinList.init = function()
{
    NSObjJoinListPrivate.init();
	
	this.f_init =		function () { return NSObjJoinListPrivate.init.apply( NSObjJoinListPrivate, arguments ); };
	this.f_run =		function () { return NSObjJoinListPrivate.f_run.apply( NSObjJoinListPrivate, arguments ); };
	this.f_destroy =		function () { return NSObjJoinListPrivate.f_destroy( NSObjJoinListPrivate, arguments ); };

    
	//window.NSObjJoinList_ = NSObjJoinList;
	window.NSObjJoinListPrivate_ = NSObjJoinListPrivate;
	
}


let NSObjJoinListPrivate = 
{
	private_objs: {
		
		s_object_urn: null,
		//s_relationship_property: null,
		//s_feature_count: null,
        local_col: null,
        external_col_urn: null,
        join_count: null,
        join_ids: null,		
		
		b_is_destroyed: true,
		
		
	},
	
	init: function ()
	{
		var private_objs = this.private_objs;
		//this.e_holder = document.getElementById(private_objs.s_e_holder_id);
		
	},
	
	/*
	o_in: {
		object_urn,				-> ex: "swrefVrecordVdatasetZmunicipioVcollectionZmn_area_processosVkeysZ5109049"
		relationship_property,	-> ex: "mn_processo_urbanismos",
		feature_count,			-> ex: 15
	}

     o_in: {
				object_urn,                 //urn of the object (in the editor) that has the joins
				//relationship_property,
				//feature_count
				local_col,                  //local column (internal_name_db), for columns where is_target==true, differs from the client generated internal_name based on external table name
				external_col_urn,           //external colunmn urn
				join_count,
				join_ids                    //list of the joins ids separeted by comma
			};
	*/
	f_run: function(o_in)
	{
		var private_objs = this.private_objs;
		
		private_objs.s_object_urn = o_in.object_urn;
		//private_objs.s_relationship_property = o_in.relationship_property;
		//private_objs.s_feature_count = o_in.feature_count;
		private_objs.local_col = o_in.local_col;
		private_objs.external_col_urn = o_in.external_col_urn;
		private_objs.join_count = o_in.join_count;
		private_objs.join_ids = o_in.join_ids;
		
		private_objs.b_is_destroyed = false;
		
		this.f_get_joins();
		
	},
	
	f_destroy: function()// AQUIIIIIIIIIIIII TO DO TODO
	{
		var private_objs = this.private_objs;
		if(private_objs.b_is_destroyed != true)
		{
			//clean resultspage
			//private_objs.e_holder.innerHTML = '';

			NSResultsInterface.f_clean_results_interface();
			
			NSPageBottompanel.f_hide_bottompanel();
			
			private_objs.b_is_destroyed = true;
		}
	},
	/*
	f_show_hide_table: function()
	{
		
	},
	*/
	
	f_get_joins: function()
	{
		let this_ = this;
		let private_objs = this.private_objs;
        /*
            s_object_urn: null,
            //s_relationship_property: null,
            //s_feature_count: null,
            local_col: null,
            external_col_urn: null,
            join_count: null,
            join_ids: null,		
        */

            
        let s_object_urn = private_objs.s_object_urn;
		//let s_relationship_property = private_objs.s_relationship_property;
		//let s_feature_count = private_objs.s_feature_count;
		let local_col = private_objs.local_col;
		let external_col_urn = private_objs.external_col_urn;
		let join_count = private_objs.join_count;
		let join_ids = private_objs.join_ids;

        let s_external_table_name = NSURN.f_get_urn_table_name(external_col_urn);

        let a_join_ids = join_ids.split(",");
        let a_join_ids_processed = []; // getfeature expects ids in the format: "table_name.id"
        a_join_ids.forEach(s_id => {
            a_join_ids_processed.push(s_external_table_name + "." + s_id)
        });

        

       

		
		var f_cb = function (o_resp)
		{
			this_.f_get_joins_process_res(o_resp);
		};

		const MAX_FEATURES = 350;
        NSServerCalls.geoserver.wfs.get_feature(s_external_table_name, MAX_FEATURES, null, a_join_ids_processed, null,
            function (o_resp_json) {
                f_cb(o_resp_json);
            });
		
		
		
		
		
	},
	
	f_get_joins_process_res: function(o_resp)
	{
		let private_objs = this.private_objs;
        //let s_object_urn = private_objs.s_object_urn;
		////let s_relationship_property = private_objs.s_relationship_property;
		////let s_feature_count = private_objs.s_feature_count;
		//let local_col = private_objs.local_col;
		let external_col_urn = private_objs.external_col_urn;
		//let join_count = private_objs.join_count;
		//let join_ids = private_objs.join_ids;

        let o_gj = o_resp;
        let a_table = [];

        let s_external_table_urn = NSURN.f_create_table_urn_from_column_urn(external_col_urn);

        let o_table_elem = {
            s_table_urn: s_external_table_urn,
            a_geojson_feature: o_gj.features
        }

        a_table.push(o_table_elem);

        let o_in = 
        {
            a_table: a_table,
			b_join_list_call: true
        };

        /*
            o_in:
            {
                a_table, -> [{ s_table_urn, a_geojson_feature }]  
				b_join_list_call
            }

            ex: 
            {
                a_table: [{s_table_urn: "urn__SEP__table__SEP__municipio__SEP__arvore_intervencao", a_geojson_feature: []}]
            }
        */
        NSResultsInterface.f_reset_results_interface(o_in);
	
		
	},
    

	/*
		f_cb(o_obj_details), -> o_obj_details{o_bbox, o_feature, o_joined_object_counts}
	*/
	f_get_obj_details: function(s_urn, f_cb_in)
	{
		var this_ = this;
		var f_cb = function (o_resp)
		{
			var o_obj_details = this_.f_get_obj_details_process_result(o_resp, s_urn);
			f_cb_in(o_obj_details);
		};
		
		var o_in = 
		{
			objects: s_urn
		}
		comms.f_get_obj_details_and_relationships_count(o_in, f_cb)
	},
	
	/*
		returns o_obj_details -> o_result{o_bbox, o_feature, o_joined_object_counts}
	*/
	f_get_obj_details_process_result: function (o_resp, s_urn)
	{
		if(o_resp != null && o_resp.object_info != null)
		{
			
			var o_bbox = o_resp.object_info[s_urn].feature.bbox
			var o_feature = o_resp.object_info[s_urn].feature.features[0];
			var o_joined_object_counts = o_resp.object_info[s_urn].joined_object_counts;
			
			var o_obj_details = {
				bbox: o_bbox,
				feature: o_feature,
				joined_object_counts: o_joined_object_counts,
			};
			
			return o_obj_details;
			
		}
		
	}
	
	
	
	
	
	
	
	
}